module.exports = __webpack_public_path__ + "static/media/Rita Cornwell Bedroom Alcoves (6).bde55c1f.JPG";